import PageName from './PageName.js';

export default PageName;
